/**
 * Indicates the type of Network Response Message.
 * tag: 937
 * @readonly
 * @enum {number} (int)
 */
export enum NetworkStatusResponseType {
  /** Full */
  Full = 1,
  /** Incremental Update */
  IncrementalUpdate = 2,
}
